import React from "react";
import { GroupMemberMenuView } from "./view";
import { styles } from "./styles";

export class GroupMemberMenu extends React.Component {
  render() {
    return <GroupMemberMenuView {...this.props} styles={styles} />;
  }
}
